import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=4984bc1f"
import script from "./notes.vue?vue&type=script&lang=js"
export * from "./notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports